var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoneium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7309_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.538 18.4748C12.4322 18.7404 11.2767 18.718 10.182 18.4099C9.08722 18.1018 8.08972 17.5182 7.28471 16.7148C6.21897 15.6966 5.53393 14.3442 5.34351 12.8825C5.15309 11.4209 5.46877 9.93814 6.23805 8.68083C6.74326 7.86118 7.35206 7.11009 8.04938 6.44616C10.2627 4.24016 14.3267 0.229495 14.3267 0.229495C11.3056 -0.370158 8.1696 0.215676 5.56872 1.86556C2.96785 3.51545 1.10156 6.10287 0.356712 9.09149C-0.388596 12.0797 0.0435534 15.2402 1.56372 17.9186C3.08388 20.5971 5.57568 22.5886 8.52338 23.4808L13.538 18.4748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4513 5.51074C11.5571 5.24511 12.7125 5.26735 13.8073 5.57535C14.9021 5.88335 15.8996 6.46683 16.7047 7.27008C18.8973 9.46341 19.3253 12.7187 17.742 15.2934C17.2358 16.1131 16.6271 16.865 15.9307 17.5307C13.8409 19.6057 11.7484 21.6779 9.65332 23.7474C12.6771 24.3528 15.818 23.77 18.4233 22.12C21.0286 20.4701 22.898 17.8798 23.6433 14.8874C24.389 11.8954 23.9542 8.7312 22.4293 6.05115C20.9044 3.3711 18.4063 1.38091 15.4533 0.493408L10.4513 5.51074Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7309_1661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoneium);
export default __webpack_public_path__ + "static/media/soneium.1a9dbe352407dce16a84ba206369ceeb.svg";
export { ForwardRef as ReactComponent };